var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleErrorTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FF2A30;stroke-width:4;}\r\n\t.st1{fill:#FF0000;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45,
    cy: 45,
    r: 43
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.5,69.3l-6.2-10.7c-2.5-4.1-4.1-6.8-5.6-9.6h-0.1c-1.4,2.8-2.7,5.4-5.3,9.6l-5.8,10.7h-7.2l14.8-24.6 l-14.3-24h7.3l6.4,11.4c1.8,3.2,3.2,5.6,4.5,8.2h0.2c1.4-2.9,2.6-5.1,4.4-8.2l6.6-11.4h7.2L48.6,44.4l15.1,24.9H56.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleErrorTransparent);
export default __webpack_public_path__ + "static/media/CircleErrorTransparent.cc79da02fe0a038e6ec1edad9cf777cd.svg";
export { ForwardRef as ReactComponent };